// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ReadMoreController from './read_more_controller'

import ShareButtonController from './share_button_controller'

import SlimSelectController from './slim_select_controller'

import SubscribeNotificationController from './subscribe_notification_controller'

import TypewriterController from './typewriter_controller'

import FinancingController from './financing_controller'
import RegisterLotteryController from './register_lottery_controller'

application.register('read-more', ReadMoreController)
application.register('share-button', ShareButtonController)
application.register('slim-select', SlimSelectController)
application.register('subscribe-notification', SubscribeNotificationController)
application.register('typewriter', TypewriterController)
application.register('financing', FinancingController)
application.register('register-lottery', RegisterLotteryController)
